module.exports = __webpack_public_path__ + "img/map-wl.c886f35f.png";